import { render, staticRenderFns } from "./collectCoupon.vue?vue&type=template&id=2ea99816&scoped=true&"
import script from "./collectCoupon.vue?vue&type=script&lang=js&"
export * from "./collectCoupon.vue?vue&type=script&lang=js&"
import style0 from "./collectCoupon.vue?vue&type=style&index=0&id=2ea99816&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea99816",
  null
  
)

export default component.exports